import Constants from 'js/Constants';
import { RESOURCE_TYPE_SINK, RESOURCE_TYPE_SOURCE } from 'js/constants/resourceTypes';

export const sortByItemsRead = [
  {
    title: 'Name ascending',
    value: 'name&sortorder=asc',
  },
  {
    title: 'Name descending',
    value: 'name&sortorder=desc',
  },
  {
    title: 'Oldest first',
    value: 'lastIngested&sortorder=asc',
  },
  {
    title: 'Most recent first',
    value: 'lastIngested&sortorder=desc',
  },
  {
    title: 'Size smallest',
    value: 'size&sortorder=asc',
  },
  {
    title: 'Size largest',
    value: 'size&sortorder=desc',
  },
];

export const sortByItemsWrite = [
  {
    title: 'Name ascending',
    value: 'name&sortorder=asc',
  },
  {
    title: 'Name descending',
    value: 'name&sortorder=desc',
  },
  {
    title: 'Oldest first',
    value: 'lastWritten&sortorder=asc',
  },
  {
    title: 'Most recent first',
    value: 'lastWritten&sortorder=desc',
  },
  {
    title: 'Size smallest',
    value: 'size&sortorder=asc',
  },
  {
    title: 'Size largest',
    value: 'size&sortorder=desc',
  },
];

export const DEFAULT_SORT_READ = 'lastIngested&sortorder=desc';
export const DEFAULT_SORT_WRITE = 'lastWritten&sortorder=desc';

export function getDefaultSort(resourceType: string): string {
  return resourceType === RESOURCE_TYPE_SOURCE ? DEFAULT_SORT_READ : DEFAULT_SORT_WRITE;
}

export const getFilterByStatusRead = (isAdaptiveFlow = false) => {
  if (isAdaptiveFlow) {
    return [
      {
        title: 'All Tasks',
        value: 'all',
      },
      {
        title: 'Not Started',
        value: Constants.IngestionStatus.NOT_STARTED,
      },
      {
        title: 'Started',
        value: Constants.IngestionStatus.STARTED,
      },
      {
        title: 'In Progress',
        value: Constants.IngestionStatus.IN_PROGRESS,
      },
      {
        title: 'Partially Read',
        value: Constants.IngestionStatus.PARTIAL,
      },
      {
        title: 'Failed',
        value: Constants.IngestionStatus.ERROR,
      },
      {
        title: 'Completed',
        value: Constants.IngestionStatus.COMPLETE,
      },
    ];
  }

  return [
    {
      title: 'All Files',
      value: 'all',
    },
    {
      title: 'Not Started',
      value: Constants.IngestionStatus.NOT_STARTED,
    },
    {
      title: 'Queued',
      value: Constants.IngestionStatus.QUEUED_REINGEST,
    },
    {
      title: 'Started',
      value: Constants.IngestionStatus.STARTED,
    },
    {
      title: 'In Progress',
      value: Constants.IngestionStatus.IN_PROGRESS,
    },
    {
      title: 'Downloading',
      value: Constants.IngestionStatus.DOWNLOADING,
    },
    {
      title: 'Parsing',
      value: Constants.IngestionStatus.PARSING,
    },
    {
      title: 'Post Processing',
      value: Constants.IngestionStatus.POST_PROCESSING,
    },
    {
      title: 'Partially Read',
      value: Constants.IngestionStatus.PARTIAL,
    },
    {
      title: 'Failed',
      value: Constants.IngestionStatus.ERROR,
    },
    {
      title: 'Recovered',
      value: Constants.IngestionStatus.RECOVERED,
    },
    {
      title: 'Completed',
      value: Constants.IngestionStatus.COMPLETE,
    },
  ];
};

export const getFilterByStatusWrite = (isAdaptiveFlow = false) => [
  {
    title: isAdaptiveFlow ? 'All Tasks' : 'All Files',
    value: 'all',
  },
  {
    title: 'Not started',
    value: Constants.IngestionStatus.NOT_STARTED,
  },
  {
    title: 'In Progress',
    value: Constants.IngestionStatus.IN_PROGRESS,
  },
  {
    title: 'Partially Written',
    value: Constants.IngestionStatus.PARTIAL,
  },
  {
    title: 'Failed',
    value: Constants.IngestionStatus.ERROR,
  },
  {
    title: 'Completed',
    value: Constants.IngestionStatus.COMPLETE,
  },
];

export const allowedTypes = [RESOURCE_TYPE_SOURCE, RESOURCE_TYPE_SINK];

export const cronSortByItemsSource = [
  {
    title: 'Oldest first',
    value: 'runId&sortorder=asc',
  },
  {
    title: 'Most recent first',
    value: 'runId&sortorder=desc',
  },
  {
    title: 'Size smallest',
    value: 'size&sortorder=asc',
  },
  {
    title: 'Size largest',
    value: 'size&sortorder=desc',
  },
];

export const cronSortByItemsDestination = [
  {
    title: 'Oldest first',
    value: 'lastWritten&sortorder=asc',
  },
  {
    title: 'Most recent first',
    value: 'lastWritten&sortorder=desc',
  },
  {
    title: 'Size smallest',
    value: 'size&sortorder=asc',
  },
  {
    title: 'Size largest',
    value: 'size&sortorder=desc',
  },
];

export const cronGroupByItems = [
  {
    title: 'Data Write Time',
    value: 'lastWritten',
  },
  {
    title: 'Data Ingestion Time',
    value: 'runId',
  },
];

export const cronSortByItems = {
  [RESOURCE_TYPE_SINK]: cronSortByItemsDestination,
  [RESOURCE_TYPE_SOURCE]: cronSortByItemsSource,
};
